export const SET_GLOBAL_MAIN_PERIOD = 'SET_GLOBAL_MAIN_PERIOD';
